// This is a utilitly from the 'react-table' source code that's not exposed.
export const rowValuesByColumnId = (row1, row2, columnId) => {
    return [row1.values[columnId], row2.values[columnId]]
}

// Another utility based on the above
export const rowOriginalsByPropertyId = (row1, row2, propertyId) => {
    return [row1.original[propertyId], row2.original[propertyId]]
}
